import { render, staticRenderFns } from "./modal-main-tainer.vue?vue&type=template&id=402b89dc&scoped=true"
import script from "./modal-main-tainer.vue?vue&type=script&lang=js"
export * from "./modal-main-tainer.vue?vue&type=script&lang=js"
import style0 from "./modal-main-tainer.vue?vue&type=style&index=0&id=402b89dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b89dc",
  null
  
)

export default component.exports